import { render } from "./GuideArticleBody.vue?vue&type=template&id=08d26af4&scoped=true"
import script from "./GuideArticleBody.vue?vue&type=script&lang=js"
export * from "./GuideArticleBody.vue?vue&type=script&lang=js"

import "./GuideArticleBody.vue?vue&type=style&index=0&id=08d26af4&lang=less&scoped=true"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-08d26af4"]])

export default __exports__